export default __webpack_public_path__ + "static/media/icon12.e3c57a74.svg";